// Previous keys, kept for reference — neither one works any more:
// const API_KEY = "AIzaSyAqvMzxANelc4hDxZrlLMmmbmi4gJ46Vi8"; // expired
// const API_KEY = "AIzaSyAxq0J-lHiJzxW9IL1rpR87RA9pdAwTrks"; // billing not enabled on its Cloud project
const API_KEY = "AIzaSyBK7YtFlcwCOOqup6g992G_Kn-6YmFT79M";
const CALLBACK = "initMap";

let initialized = !!window.google;
let resolveInitPromise;
let rejectInitPromise;

const initPromise = new Promise((resolve, reject) => {
  resolveInitPromise = resolve;
  rejectInitPromise = reject;
});

export default function init() {
  if (initialized) return initPromise;

  initialized = true;

  window[CALLBACK] = () => resolveInitPromise(window.google);

  const script = document.createElement("script");
  script.async = true;
  script.defer = true;
  script.src = `https://maps.googleapis.com/maps/api/js?key=${API_KEY}&callback=${CALLBACK}&libraries=places,visualization`;
  script.onerror = rejectInitPromise;
  document.querySelector("head").appendChild(script);

  return initPromise;
}
